export const tableSelectItems = [
  { id: '1', label: 'blue bird' },
  { id: '2', label: 'canary' },
  { id: '3', label: 'eagle' },
  { id: '4', label: 'falcon' },
  { id: '5', label: 'finch' },
  { id: '6', label: 'hawk' },
  { id: '7', label: 'owl' },
  { id: '8', label: 'parrot' },
  { id: '9', label: 'penguin' },
  { id: '10', label: 'pigeon' },
  { id: '11', label: 'raven' },
  { id: '12', label: 'toucan' },
]
